import React from "react";

import useMainParticipant from "../hooks/useMainParticipant/useMainParticipant";
import useScreenShareParticipant from "../hooks/useScreenShareParticipant/useScreenShareParticipant";
import useVideoContext from "../hooks/useVideoContext/useVideoContext";
import MainParticipantInfo from "../MainParticipantInfo/MainParticipantInfo";
import ParticipantTracks from "../ParticipantTracks/ParticipantTracks";

export default function MainParticipant() {
  const mainParticipant = useMainParticipant();
  const { room } = useVideoContext();
  const { localParticipant } = room!;
  const screenShareParticipant = useScreenShareParticipant();

  const videoPriority =
    mainParticipant === screenShareParticipant && mainParticipant !== localParticipant
      ? "high"
      : null;

  return (
    /* audio is disabled for this participant component because this participant's audio 
       is already being rendered in the <ParticipantStrip /> component.  */
    <MainParticipantInfo
      participant={mainParticipant}
      isLocal={mainParticipant === localParticipant}
    >
      {mainParticipant !== localParticipant ? (
        <ParticipantTracks
          participant={mainParticipant}
          videoOnly={false}
          enableScreenShare={mainParticipant !== localParticipant}
          videoPriority={videoPriority}
          isLocalParticipant={mainParticipant === localParticipant}
        />
      ) : null}
    </MainParticipantInfo>
  );
}
